import config from "../config.js";
import api from "../services/api";

export const registerSW = async () => {
    console.log("🟢 Registering service worker...");
  
    // Ask for notification permission first
    const permission = await Notification.requestPermission();
    console.log("Permission",permission);
    if (permission === 'granted') {
      console.log("✅ Notification permission granted");
  
      // Register the service worker
      const registration = await navigator.serviceWorker.register("/serviceworker.js");
      console.log("🟢 Service worker registered:", registration);
  
      // Wait until the service worker is ready
      const swReady = await navigator.serviceWorker.ready;
      console.log("✅ Service worker ready:", swReady);
      const isAlreadyExits = await registration.pushManager.getSubscription();
      
      if(isAlreadyExits)
      return;

      console.log("🔐 Subscribing to PushManager...");
      const subscription = await swReady.pushManager.subscribe({
        userVisibleOnly: true, 
        applicationServerKey: urlBase64ToUint8Array(config.VAPID_publicKey)
      });
  
      console.log("📬 Push subscription object:", subscription);   
      try{
        let res = await api({
            url: `/pushSubscription/subscribe`,
            method: "POST",
            responseType: "json",
            data: {subscription}
          });
         if(res.code === 200)
            console.log("✅ Subscription sent to backend");
      }catch(err)
      {
         console.log(err);
      }
      
    } else {
      console.log("❌ Permission for notifications was denied");
    }
  };
  
  // Utility function to convert VAPID public key to Uint8Array
  export const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
  
    const rawData = atob(base64);
    return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
  };
  